import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container container--animation" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Регистрация ", -1)
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { key: 1 }

import DynamicForm from "@/components/DynamicForm.vue";
import * as yup from 'yup';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import FormSchema from '@/types/formSchema';

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterPage',
  setup(__props) {

const { useGetters, useActions } = createNamespacedHelpers('authModule');

const { getUser } = useGetters(['getUser']);

const formSchema: FormSchema = {
  fields: [
    {
      label: 'Введите имя',
      name: 'name',
      id: 'name',
      as: 'input',
      type: 'text',
    },
    {
      label: 'Введите Email',
      name: 'email',
      id: 'email',
      as: 'input',
      type: 'email',
    },
    {
      label: 'Введите пароль',
      name: 'password',
      id: 'password',
      as: 'input',
      type: 'password',
    },
    {
      label: 'Повторите пароль',
      name: 'passwordConfirm',
      id: 'passwordConfirm',
      as: 'input',
      type: 'password',
    },
  ],
  btnTitle: 'Зарегистрироваться'
};

const validationSchema = yup.object().shape({
  name: yup.string().min(2, 'Введите от 2 до 255 символов').max(255, 'Введите от 2 до 255 символов').required('Обязательное поле'),
  email: yup.string().email('Неподходящий email').required('Обязательное поле'),
  password: yup.string().min(6, 'Введите от 6 до 50 символов').max(50, 'Введите от 6 до 50 символов').required('Обязательное поле'),
  passwordConfirm: yup.string().min(6, 'Введите от 6 до 50 символов').max(50, 'Введите от 6 до 50 символов').oneOf([yup.ref('password')], 'Пароли должны совпадать').required('Обязательное поле'),
});

const { registerNewUser } = useActions(['registerNewUser']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.getError.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Произошла ошибка: " + _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_unref(getUser).data?.uid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Вы уже зарегистрированы, чтобы создать нового пользователя выйдите из текущего профиля "))
      : (_openBlock(), _createBlock(DynamicForm, {
          key: 2,
          "validation-schema": _unref(validationSchema),
          schema: formSchema.fields,
          "btn-title": formSchema.btnTitle,
          onSubmitHandler: _unref(registerNewUser)
        }, null, 8, ["validation-schema", "schema", "btn-title", "onSubmitHandler"]))
  ]))
}
}

})